import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QGetPlanSettings extends QRFC {
  constructor() {
    super();
  }

  InitGetPlanSettings(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qgetplansettings";
  }

  SetParams(orgName, user, chartID) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("chartID", chartID);
  }

  DoTransactionComplete(response, callBackObj) {
    const resp = this.SafeParseResponse(response);
    const success = resp?.success ?? false;
    const planSettings = resp?.data ?? null;

    callBackObj.GetPlanSettingsResult(success, planSettings, resp);
  }
}
